module.exports = __webpack_public_path__ + "static/media/eutourtrans.9276843a.png";